<div class="hero-container">

  <video #videoPlayer autoplay loop playsinline [muted]="true" class="video-bg">
    <source src="/assets/img/videos/{{ source }}" type="video/mp4">
  </video>

  <div class="overlay"></div>

  <div class="hero-content">

    <h1 aria-label="Bienvenue à la Caverne du Gobelin">

      <div class="ligne-titre ligne-1">
        <span class="mot-wrapper" *ngFor="let mot of motsLigne1">
          <span class="lettre-anim" *ngFor="let lettre of mot">
            {{ lettre }}
          </span>
        </span>
      </div>

      <div class="ligne-titre ligne-2">
        <span class="mot-wrapper" *ngFor="let mot of motsLigne2">
          <span class="lettre-anim" *ngFor="let lettre of mot">
            {{ lettre }}
          </span>
        </span>
      </div>

    </h1>

    <p>{{ sousTitre }}</p>

    <a [routerLink]="boutonLien" class="btn-cta">
      <svg class="arrow-icon left" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
      <span>{{ boutonText }}</span>
      <svg class="arrow-icon right" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="15 18 9 12 15 6"></polyline>
      </svg>
    </a>

  </div>

</div>
